import "./Contact.css";
import { useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { SOCIALS } from "../../config";

gsap.registerPlugin(ScrollTrigger, useGSAP);

function Contact() {
  const signatureRef = useRef(null);

  useGSAP(() => {
    if (!signatureRef.current) return;

    const line1 = signatureRef.current.querySelector('.contact-signature-line-1');
    const line2 = signatureRef.current.querySelector('.contact-signature-line-2');

    // Line 1 moves left on scroll
    gsap.fromTo(line1,
      { x: 100 },
      {
        x: -100,
        scrollTrigger: {
          trigger: signatureRef.current,
          start: "top 100%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );

    // Line 2 moves right on scroll
    gsap.fromTo(line2,
      { x: -100 },
      {
        x: 100,
        scrollTrigger: {
          trigger: signatureRef.current,
          start: "top 100%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );
  }, { scope: signatureRef });

  return (
    <div className="contact">
      <div className="contact-content">
        <div className="stack">
          <h2 className="h1">Let's build something <em className="accent">intelligent</em>.</h2>
          <p className="text contact-tagline">Currently accepting new partners.</p>
        </div>

        <nav className="contact-links">
          <div className="contact-link-column">
            <p className="label">Connect</p>
            <a className="contact-link" href={`mailto:${SOCIALS.email}`}>Email</a>
            <a className="contact-link" target="_blank" rel="noreferrer" href={SOCIALS.linkedin}>LinkedIn</a>
            <a className="contact-link" target="_blank" rel="noreferrer" href={SOCIALS.upwork}>Upwork</a>
          </div>

          <div className="contact-link-column">
            <p className="label">Portfolio</p>
            <a className="contact-link" target="_blank" rel="noreferrer" href={SOCIALS.dribbble}>Dribbble</a>
            <a className="contact-link" target="_blank" rel="noreferrer" href={SOCIALS.contra}>Contra</a>
            <a className="contact-link" target="_blank" rel="noreferrer" href={SOCIALS.github}>GitHub</a>
          </div>
        </nav>
      </div>


      <div className="contact-credits">
        <p className="text-small">Designed & Developed with {"<3"} by Chebbi Mohamed Ayoub</p>
        <p className="text-small">R&D Focus: Generative Interfaces Thesis.</p>
        <p className="text-small">Built with React & GSAP</p>
      </div>

      <div className="contact-signature" ref={signatureRef}>
        {/* Line 1: CHEBBI highlighted */}
        <div className="contact-signature-line contact-signature-line-1">
          {[...Array(5)].map((_, repeatIndex) => (
            <span key={`l1-r${repeatIndex}`} className="contact-signature-word">
              <span className="contact-signature-faded">AYOUB</span>
              <span className="contact-signature-highlight">CHEBBI</span>
              <span className="contact-signature-faded">MEDAYOUB</span>
            </span>
          ))}
        </div>
        {/* Line 2: MEDAYOUB highlighted */}
        <div className="contact-signature-line contact-signature-line-2">
          {[...Array(5)].map((_, repeatIndex) => (
            <span key={`l2-r${repeatIndex}`} className="contact-signature-word">
              <span className="contact-signature-faded">CHEBBI</span>
              <span className="contact-signature-highlight">MEDAYOUB</span>
              <span className="contact-signature-faded">CHEBBI</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Contact;
